import WorkshopBookingJson from './WorkshopBookingJson';
import { Validation } from './Validation';
import { validateWorkshopDateJson } from './WorkshopDateJson';
import WorkshopPriceJson, { validateWorkshopPriceJson } from './WorkshopPriceJson';

/**
 * Kurs der von der Jugendfarm angeboten wird
 */
export default interface WorkshopJson {
   ID: number | null,

   /**
    * Kurzbeschreibung des Kurses.
    */
   title: string,

   /**
    * Beschreibung des Programms.
    */
   description: string;

   /**
    * Besondere Hinweise die für diesen Kurs gelten. Kann ein leerer Ttext sein wenn nichts besonderes gilt.
    */
   remarks: string;

   /**
    * Termine an denen dieser Kurs stattfindet.
    */
   dates: { beginDateTime: string, endDateTime: string; }[];

   /**
    * Liste mit Preiskategorien. 
    */
   prices: WorkshopPriceJson[];

   /**
    * Gibt an ob die Registrierungen für diesen Kurs fregegeben sind. 
    * Wenn es auf true ist, werden immer noch registrationBeginDate und registrationEndDate sowie registrationMaximumCount beachtet.
    */
   allowRegistration: boolean;

   /**
    * Datum und Uhrzeit ab dem Registrierungen möglich sind.
    */
   registrationBeginDateTime: string;

   /**
    * Datum und Uhrzeit bis zu dem Registrierungen möglich sind.
    */
   registrationEndDateTime: string;

   /**
    * Maximale Anzahl an Teilnehmern die akzeptiert werden.
    */
   registrationMaximumCount: number;

   /**
    * Maximale Anzahl an Teilnehmern die in der Warteliste akzeptiert werden. Kann 0 sein.
    */
   waitingListMaximumCount: number;
}
export type WorkshopWithBookingsJson = WorkshopJson & { "bookings": WorkshopBookingJson[]; };
export type WorkshopWithBookingJson = WorkshopJson & { "booking": WorkshopBookingJson; };
export type WorkshopInfoJson = WorkshopJson & { "registrationSlotsFree": number, "waitingListSlotsFree": number; };

export const WorkshopDescriptionAllowedTags: string[] = ["p", "br", "b", "ul", "li", "u"];

export function validateWorkshopJsonManagement(item: WorkshopJson) {
   return new Validation(item)
      .validateInteger("ID", 0)
      .validateNonEmptyString("title", 100)
      .validateString("description", 1500)
      .validateString("remarks", 500)
      .validateAllUsingFunction("dates", validateWorkshopDateJson, 1)
      .validateAllUsingFunction("prices", validateWorkshopPriceJson, 1)
      .validateInteger("registrationMaximumCount", 0)
      .validateInteger("registrationMaximumCount", 0)
      .finish();
}
export function validateWorkshopJsonManagementAdd(item: WorkshopJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("title", 100)
      .validateString("description", 1500)
      .validateString("remarks", 500)
      .validateAllUsingFunction("dates", validateWorkshopDateJson, 1)
      .validateAllUsingFunction("prices", validateWorkshopPriceJson, 1)
      .validateInteger("registrationMaximumCount", 0)
      .validateInteger("registrationMaximumCount", 0)
      .finish();
}